var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8526_3473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7949 1.0094L6.4043 6.39996",
    stroke: "#555555",
    strokeWidth: 1.08756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7952 1.0094L8.36481 10.8104L6.4046 6.39996L1.99414 4.43976L11.7952 1.0094Z",
    stroke: "#555555",
    strokeWidth: 1.08756,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8526_3473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.7612,
    height: 11.7612,
    fill: "white",
    transform: "translate(0.968262 0.317993)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a4ccaede0d8267332e18af5da2cae755.svg";
export { ForwardRef as ReactComponent };